module.exports = __webpack_public_path__ + "img/商品详情-1.43a151fd.png";